/**
 * Lunora's user-facing terminology — translates tailoring jargon to luxury speak.
 * Use these keys in design-studio chips, checkout summaries, tailor briefs.
 */

export const WORK_LEVELS = {
  light: { label: 'Daily Wear', icon: '🌿', desc: 'Subtle craftsmanship for everyday' },
  medium: { label: 'Festive', icon: '✨', desc: 'Embellished, celebration-ready' },
  heavy: { label: 'Royal / Wedding', icon: '👑', desc: 'Couture detailing, statement piece' },
};

export const TERM_MAP = {
  'front design': 'Neckline',
  'front_design': 'Neckline',
  'neck style': 'Collar',
  'neck_style': 'Collar',
  'hem': 'Bottom Edge',
  'cuff': 'Wrist',
  'dart': null,           // hidden — auto-derived
  'dart_position': null,  // hidden — auto-derived
  'ease': null,           // hidden — auto-derived
  'rise': null,           // hidden — auto-derived
  'kurta_length': 'Length',
  'sleeve_length': 'Sleeves',
  'shirt_length': 'Length',
  'pajama_length': 'Pajama Length',
};

export const FIT_LEVELS = {
  slim: { label: 'Slim', desc: 'Body-hugging' },
  regular: { label: 'Regular', desc: 'Tailored' },
  loose: { label: 'Loose', desc: 'Relaxed' },
};

export const GENDER_HERO = {
  female: {
    salutation: 'My lady',
    heroLine: "I'll style you in moments.",
    sub: 'Snap a single photo or answer 5 quick questions — your perfect fit, every time.',
    gradient: 'linear-gradient(135deg, #F4D5D9 0%, #D4AF37 100%)',
    accent: '#E5B2B9',
  },
  male: {
    salutation: 'Sir',
    heroLine: "Let's get you a precision fit.",
    sub: 'Snap a single photo or answer 5 quick questions — studio-grade tailoring, in 60 seconds.',
    gradient: 'linear-gradient(135deg, #1A1A1A 0%, #5A4423 70%, #D4AF37 100%)',
    accent: '#8B6F3F',
  },
};

// Public translator (used by tailor-dashboard / checkout)
export const humanize = (key) => {
  if (!key) return '';
  const lk = key.toString().toLowerCase().replace(/\s+/g, '_');
  if (TERM_MAP[lk] === null) return null; // hidden
  return TERM_MAP[lk] || key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
};
